// states/mapDataState.js
import { atom } from "recoil";

export const MapDataState = atom({
  key: "MapDataState",
  default: {
    lopbandonen: [],
    optionTour: [],
    itemListMarker: [],
    headerLocation: [],
  },
});
